import {
  ActionTypes,
  ActiveLegalAction,
  LegalAction,
  LegalMap,
  ResetLegalAction,
  ResetViewedProductsAction,
  ViewedProductAction,
} from "~/types/legal";
import { UNBREAKABLE_WIFI, YTTV_BASIC } from "~/constants/entityIds";

const UNBREAKABLE_WIFI_KEY_ALIASES = [
  "unbreakable-wifi",
  "unbreakable-wifi-1mf-terms",
  "unbreakableWifi",
  "unbreakableWifiShort",
];

export const normalizeLegalKey = (key: string): string =>
  UNBREAKABLE_WIFI_KEY_ALIASES.includes(key) ? "unbreakableWifiUpdated" : key;

export const setLegal = (legalMap: LegalMap): LegalAction => {
  return { type: ActionTypes.SET_LEGAL_MAP, legalMap };
};

export const addActiveLegal = (activeLegal: string[]): ActiveLegalAction => {
  return { type: ActionTypes.ADD_ACTIVE_LEGAL, activeLegal };
};

export const resetActiveLegal = (): ResetLegalAction => {
  return { type: ActionTypes.RESET_ACTIVE_LEGAL };
};

export const addViewedProduct = (productId: string): ViewedProductAction => {
  return { type: ActionTypes.ADD_VIEWED_PRODUCT, productId };
};

export const resetViewedProducts = (): ResetViewedProductsAction => {
  return { type: ActionTypes.RESET_VIEWED_PRODUCTS };
};

export const getFilteredActiveLegal = (activeLegal: string[], viewedProducts: string[] = []): string[] =>
  activeLegal.filter((legalKey) => {
    if (legalKey === "unbreakableWifiUpdated" && !viewedProducts.includes(UNBREAKABLE_WIFI)) {
      return false;
    }
    if (["youtubeTv", "yttvNflst", "youtubeTvCopper"].includes(legalKey) && !viewedProducts.includes(YTTV_BASIC)) {
      return false;
    }
    return true;
  });
